export const ConfidenceBar = ({ score = 0, size = "md" }) => {
  const color =
    score >= 85 ? "bg-emerald-500" : score >= 65 ? "bg-amber-500" : "bg-rose-500";
  const text =
    score >= 85 ? "text-emerald-700" : score >= 65 ? "text-amber-700" : "text-rose-700";
  return (
    <div className="flex items-center gap-2" data-testid="confidence-bar">
      <div className={`h-1.5 ${size === "sm" ? "w-14" : "w-24"} overflow-hidden rounded-full bg-slate-200`}>
        <div className={`h-full rounded-full ${color}`} style={{ width: `${score}%` }} />
      </div>
      <span className={`font-mono text-xs font-semibold ${text}`}>{score}%</span>
    </div>
  );
};

export const RiskChip = ({ risk }) => {
  const map = {
    low: "bg-emerald-50 text-emerald-700 border-emerald-200",
    medium: "bg-amber-50 text-amber-700 border-amber-200",
    high: "bg-rose-50 text-rose-700 border-rose-200",
  };
  const label = { low: "Bajo riesgo", medium: "Riesgo medio", high: "Alto riesgo" };
  return (
    <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${map[risk] || map.medium}`}>
      {label[risk] || risk}
    </span>
  );
};
